import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import { defineStore } from 'pinia'

import type { ProjectUserType } from '@/stores/type/projectUser.type'
import { useBaseStore, useAuthModelBaseStore } from '@haskoning/vue-basestore'

const api = useApi<ProjectUserType>()
const baseUrl = API.CORE.PROJECT_USERS.INDEX

export const useProjectUserStore = defineStore('projectUsers', () => {
	const baseStore = useBaseStore<ProjectUserType>({ service: baseUrl, api })

	function resetState() {
		baseStore.items.value = []
		baseStore.currentItem.value = {} as ProjectUserType
	}

	const { addUserDialog, toggleAddUserDialog, addUser, updateRole } = useAuthModelBaseStore({
		...baseStore,
		resetState
	})

	return {
		...baseStore,
		addUserDialog,
		toggleAddUserDialog,
		addUser,
		updateRole,
		resetState
	}
})
